import {UI} from "../../../../../../stem-core/src/ui/UIBase";
import {styleRule, StyleSheet} from "../../../../../../stem-core/src/ui/Style";
import {registerStyle} from "../../../../../../stem-core/src/ui/style/Theme";
import {Messages} from "../../../../../Messages";
import {PaymentMethodDescription} from "../../../../../common/PaymentMethodDescription.jsx";
import {LinkButton} from "../../../../../../core/ui/LinkButton.jsx";
import {Flow} from "../../../../flows/Flow.js";


class PaymentMethodAcceptOrChangeStyle extends StyleSheet {
    @styleRule
    container = {
        display: "flex",
        justifyContent: "space-between",
    };
}

// Component that shows the currently selected payment method or allows you to enter a flow to change/add another
@registerStyle(PaymentMethodAcceptOrChangeStyle)
export class PaymentMethodAcceptOrChange extends UI.Element {
    isValid() {
        return true;
    }

    getPaymentMethod() {
        return Flow.paymentMethod.selectedValue;
    }

    render() {
        return [
            <PaymentMethodDescription paymentMethod={this.getPaymentMethod()}/>,
            <LinkButton
                label={Messages.change}
                onClick={() => Flow.paymentMethod.prompt({noHistory: true, continueLabel: Messages.continue})}
            />,
        ]
    }
}
